import { IContactData } from "../../interfaces/ContactInterface";

export const ResumeData: IContactData = {
  send: "Email",
  call: "Phone",
  home: "Address",
  address: "Kankaretie 9 a c 31, 00770 Helsinki, Finland",
  phone: "+358 44 208 0939",
  email: "madel413@gmail.com",
};
